<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="60%"
    top="5vh"
    @close="close"
  >
    <div class="Minister-top">
      <el-form ref="form" :model="form" :rules="formRules" label-width="150px">
        <div>
          <div class="Minister-top-top Ministerbackground">
            <div class="Minister-top-left Minister-top-color">基本信息</div>
          </div>
          <div class="information_content">
            <el-form-item label="模板名称：" prop="stencilName">
              <el-input
                placeholder="请输入模板名称"
                class="width67"
                :disabled="saveDisabled"
                v-model="form.stencilName"
              ></el-input>
            </el-form-item>
            <el-form-item label="店铺：" prop="sellerId">
              <el-select
                v-model="form.sellerId"
                class="width67"
                placeholder="请选择"
                :disabled="saveDisabled"
                @change="shopChange"
              >
                <el-option
                  v-for="(item, index) in shopList"
                  :key="index + 'sellerId'"
                  :label="item.shopName"
                  :value="item.sellerId"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>

        <div>
          <div class="Minister-top-top Ministerbackground">
            <div class="Minister-top-left Minister-top-color">物流</div>
          </div>
          <div class="information_content">
            <div class="address">
              <el-form-item label="发货地点：" prop="countryCode">
                <el-select
                  v-model="form.countryCode"
                  placeholder="请选择"
                  filterable
                  :disabled="saveDisabled"
                >
                  <el-option label="中国(CN)" value="cn"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="province" label-width="0">
                <el-input
                  v-model="form.province"
                  :disabled="saveDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item prop="province" label-width="0">
                <el-input
                  v-model="form.city"
                  :disabled="saveDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item prop="province" label-width="0">
                <el-input
                  v-model="form.postCode"
                  :disabled="saveDisabled"
                ></el-input>
              </el-form-item>
            </div>

            <el-form-item label="处理时间：" prop="handlingTime">
              <el-select
                v-model="form.handlingTime"
                class="width67"
                filterable
                clear
                :disabled="saveDisabled"
              >
                <el-option
                  label="PT0S for immediately(出单立即发货)"
                  value="PT0S for immediately"
                ></el-option>
                <el-option label="PT24H(一天)" value="PT24H"></el-option>
                <el-option label="P2D(两天)" value="P2D"></el-option>
                <el-option label="P3D(3天)" value="P3D"></el-option>
                <el-option label="P4D(4天)" value="P4D"></el-option>
                <el-option label="P5D(5天)" value="P5D"></el-option>
                <el-option label="P7D(7天)" value="P7D"></el-option>
                <el-option label="P10D(10天)" value="P10D"></el-option>
                <el-option label="P14D(14天)" value="P14D"></el-option>
                <el-option label="P21D(21天)" value="P21D"></el-option>
                <el-option label="P30D(30天)" value="P30D"></el-option>
                <el-option label="P60D(60天)" value="P60D"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="运输价格表：" prop="shippingId">
              <el-select
                v-model="form.shippingId"
                class="width67"
                filterable
                clear
                :disabled="!form.sellerId || saveDisabled"
                :placeholder="
                  !form.sellerId ? '请选择店铺后再进行选择' : '请选择'
                "
              >
                <el-option
                  v-for="(item, index) in jiageOptions"
                  :key="index + 'price'"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-button
                style="margin-left: 10px"
                type="primary"
                @click="updateJiage"
              >
                更新价格表
              </el-button>
            </el-form-item>
          </div>
        </div>

        <div>
          <div class="Minister-top-top Ministerbackground">
            <div class="Minister-top-left Minister-top-color">售后</div>
          </div>
          <div class="information_content">
            <el-form-item label="退货条件：" prop="returnPolicyId">
              <el-select
                v-model="form.returnPolicyId"
                class="width67"
                filterable
                clear
                :disabled="!form.sellerId || saveDisabled"
                :placeholder="
                  !form.sellerId ? '请选择店铺后再进行选择' : '请选择'
                "
              >
                <el-option
                  v-for="(item, index) in tuihuoOptions"
                  :key="index + 'returnPolicyId'"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option> </el-select
            ></el-form-item>
            <el-form-item label="保修政策：" prop="warrantyId">
              <el-select
                v-model="form.warrantyId"
                class="width67"
                filterable
                clear
                :disabled="!form.sellerId || saveDisabled"
                :placeholder="
                  !form.sellerId ? '请选择店铺后再进行选择' : '请选择'
                "
              >
                <el-option
                  v-for="(item, index) in baoxiuOptions"
                  :key="index + 'warrantyId'"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close" :disabled="saveDisabled">取 消</el-button>
      <el-button type="primary" @click="save" :disabled="saveDisabled"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { ajaxPost, Baseurl } from "../../../api/api/api";

export default {
  name: "createTemplate",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    pageType: {
      type: String,
      default: "",
    },
    currentForm: {
      type: Object,
      default: () => {},
    },
    shopList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      title: "店铺模板",
      form: {
        stencilName: "",
        sellerId: "",
        countryCode: "CN",
        province: "guangdong",
        city: "shenzhen",
        postCode: "518101",
        handlingTime: "",
        shippingId: "",
        returnPolicyId: "",
        warrantyId: "",
      },
      formRules: {
        stencilName: [{ required: true, message: "请输入", trigger: "change" }],
        sellerId: [{ required: true, message: "请选择", trigger: "change" }],
        countryCode: [{ required: true, message: "请选择", trigger: "change" }],
        province: [{ required: true, message: "请输入", trigger: "change" }],
        city: [{ required: true, message: "请输入", trigger: "change" }],
        postCode: [{ required: true, message: "请输入", trigger: "change" }],
        handlingTime: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        shippingId: [{ required: true, message: "请选择", trigger: "change" }],
      },
      jiageOptions: [], //价格列表
      tuihuoOptions: [],
      baoxiuOptions: [],

      saveDisabled: false,
    };
  },
  mounted() {
    if (this.isEdit) {
      const form = JSON.parse(JSON.stringify(this.form));
      for (const key in form) {
        this.form[key] = this.currentForm[key];
      }
      this.shopChange(this.form.sellerId);
    }
  },
  methods: {
    shopChange(value) {
      if (value) {
        this.getJiage();
        this.getTuihuo();
        this.getBaoxiu();
      }
    },
    getJiage() {
      //获取价格
      ajaxPost(Baseurl + "allegroDelivery/getShippingRates", {
        sellerId: this.form.sellerId,
      }).then((res) => {
        const { code, data } = res.data;
        if (code == 200) {
          this.jiageOptions = data;
        }
      });
    },
    getTuihuo() {
      //获取退货
      ajaxPost(Baseurl + "allegroAfterSaleServices/getReturnPolicies", {
        sellerId: this.form.sellerId,
      }).then((res) => {
        const { code, data } = res.data;
        if (code == 200) {
          this.tuihuoOptions = data;
        }
      });
    },

    getBaoxiu() {
      //获取保修
      ajaxPost(Baseurl + "allegroAfterSaleServices/getUserWarranties", {
        sellerId: this.form.sellerId,
      }).then((res) => {
        const { code, data } = res.data;
        if (code == 200) {
          this.baoxiuOptions = data;
        }
      });
    },

    //更新价格
    updateJiage() {
      if (this.form.sellerId) {
        //获取价格
        const API = Baseurl + "allegroDelivery/getShippingRates";
        ajaxPost(API, {
          sellerId: this.sellerId,
        }).then((res) => {
          const { code, data } = res.data;
          if (code == 200) {
            if (data.length > 0) {
              this.jiageOptions = data;
            } else {
              this.$message.warning("需要先在allegro后台配置价格表信息!");
            }
          }
        });
      } else {
        this.$message.warning("请先选择店铺,再更新价格表信息!");
      }
    },

    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveFn();
        }
      });
    },
    saveFn() {
      const sendData = {
        id: this.currentForm.id,
        ...this.form,
        shippingName: this.jiageOptions?.find(
          (ele) => ele.id === this.form.shippingId
        )?.name,
        returnPolicyName: this.tuihuoOptions?.find(
          (ele) => ele.id === this.form.returnPolicyId
        )?.name,
        warrantyName: this.baoxiuOptions?.find(
          (ele) => ele.id === this.form.warrantyId
        )?.name,
      };
      console.log(this.currentForm.id);
      let API = Baseurl + "allegroSeller/insertAllegroSellerStencil";
      if (this.isEdit) {
        API = Baseurl + "allegroSeller/updateAllegroSellerStencil";
      }
      this.saveDisabled = true;
      ajaxPost(API, sendData)
        .then((res) => {
          const { code, data } = res.data;
          if (code == 200) {
            this.$message.success(this.isAdd ? "创建成功" : "编辑成功");
            this.$emit("updateList");
            this.close();
          } else {
            this.$message.error("操作失败");
          }
          this.saveDisabled = false;
        })
        .catch(() => {
          this.$message.error("操作失败");
          this.saveDisabled = false;
        });
    },

    close() {
      this.$emit("cancelVisible");
    },
  },
  computed: {
    isAdd() {
      return this.pageType === "add";
    },
    isEdit() {
      return this.pageType === "edit";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../ozon.less";

div.address {
  display: flex;
  gap: 24px;
}
</style>
